export function Service(value) {
	return function (target, key, descriptor) {
		if (typeof value == "string") {
			target.prototype.namespace = value;
		}else {
            console.error(`${proxy} address error `)
        }
	};
}
